import gql from "graphql-tag";

const SEND_TO_BUYER = gql`
  mutation sendToBuyer($offerId: ID!) {
    sendToBuyer(offerId: $offerId)
  }
`;

export default SEND_TO_BUYER;
